<template>
  <div
    class="fade-at-bottom"
    :style="style"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import { CSSProperties } from 'vue/types/jsx'
import Component from 'vue-class-component'

@Component
export default class SideBarFade extends Vue {
  get path () {
    return this.$typedStore.public.display.storyPath
  }

  get backgroundColor () {
    return this.$typedStore.primary.entities.nodes.colour(this.path.level1)
  }

  get style () {
    return { '--fade-color': this.backgroundColor } as CSSProperties
  }
}

</script>

<style scoped>

.fade-at-bottom {
  position: sticky;
  bottom: 0;
  height: 100px;
  /* "transparent" only works here because == rgba(0,0,0,0) */
  background-image: linear-gradient(to bottom, transparent, var(--fade-color));
  pointer-events: none;
}

</style>
